import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { getDefaultAuthValue } from '../contexts/AuthContext';
import { getApiUrl } from '../utils';

const baseUrl = getApiUrl();
const authState = getDefaultAuthValue();

const buildBackendOptions = () => {
  return {
    loadPath: `${baseUrl}/locales/{{lng}}`
  };
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: authState.locale || 'EN',
    fallbackLng: authState.locale || 'EN',
    debug: false,
    backend: buildBackendOptions(),
    // React escapes everything it renders already. Leaving i18next's own escaping on double-escapes
    // every interpolated value, which is how a formatted date reached the screen as 24&#x2F;09&#x2F;2026.
    interpolation: { escapeValue: false }
  });

export default i18n;
